import React, { useContext, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FiAlertTriangle } from "react-icons/fi";
import { AuthContext } from "../../../Context/AuthContext";
import "./UserProfile.css";

const DeleteAccountSection = () => {
  const { Logout, token, user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [confirmed, setConfirmed] = useState(false);

  const handleDeleteAccount = async (e) => {
    e.preventDefault();
    if (!password.trim()) {
      toast.error("Enter your password to confirm deletion.");
      return;
    }
    if (!confirmed) {
      toast.error("Please confirm you understand this action is permanent.");
      return;
    }
    setIsSubmitting(true);
    try {
      await axios.delete(
        `${process.env.REACT_APP_SERVER_URL}/users/delete/${user.userId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
          data: { password },
        }
      );
      toast.success("Account deleted");
      Logout();
      navigate("/market");
    } catch (err) {
      toast.error(err.response?.data?.message || "Could not delete account");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="delete-account-panel">
      <div className="delete-account-warning" role="note">
        <FiAlertTriangle aria-hidden="true" />
        <p>
          Deleting your account removes your profile, saved items, order history, and inbox
          messages. This action is permanent and cannot be reversed.
        </p>
      </div>

      <form className="delete-account-form" onSubmit={handleDeleteAccount}>
        <label className="delete-account-confirm">
          <input
            type="checkbox"
            checked={confirmed}
            onChange={(e) => setConfirmed(e.target.checked)}
          />
          <span>
            I understand this permanently deletes my account, order history, and saved data.
          </span>
        </label>

        <div className="delete-account-field">
          <label htmlFor="delete-account-password">Confirm with your password</label>
          <div className="pass-field">
            <input
              id="delete-account-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              placeholder="Enter your password"
            />
          </div>
        </div>

        <button
          type="submit"
          className="delete-account-submit"
          disabled={isSubmitting || !confirmed || !password.trim()}
        >
          {isSubmitting ? "Deleting account..." : "Delete my account permanently"}
        </button>
      </form>
    </div>
  );
};

export default DeleteAccountSection;
